"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ArticlesSlide = require("./ArticlesSlide");
Object.keys(_ArticlesSlide).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArticlesSlide[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ArticlesSlide[key];
    }
  });
});